import type { AllRouteEndpoints } from "../routeTypes";

export const postAppGroupIdLiquidValidationCheckSyntaxCacheKeys: AllRouteEndpoints[] = [];
